

























import Vue from "vue";
import Step from "@/components/execute/Step.vue";
import TestCaseStatus from "@/components/testcase/Status.vue";

export default Vue.extend({
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      execution: this.value
    };
  },
  watch: {
    execution: {
      handler(newValue: any) {
        this.$emit("change", newValue);
      },
      deep: true
    }
  },
  components: {
    Step,
    TestCaseStatus
  }
});
